// Dependencies
import React, { useEffect, useState, useMemo } from "react";

// Modules
import { useSelector } from "react-redux";

// App
import { apiEndpoints } from "../../config";
import MediaLibrary from "../../partials/mediaLibrary";
import { get_csrf_token } from "../../core/auth";

import { Button, Box, Typography } from "@mui/material";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";

import PostEdit from "../../partials/posts/postEdit";

export default function DocumentEdit() {
  const [post, setPost] = useState(null);
  const [showMediaLibrary, setShowMediaLibrary] = useState(false);
  const [documentLink, setDocumentLink] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [documentId, setDocumentId] = useState(null);
  const [csrf_token, setCsrfToken] = useState(null);
  const user = useSelector((state) => state.authReducer.user);

  useEffect(() => {
    get_csrf_token().then((response) => setCsrfToken(response.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (post?.field_document) {
      function getPdfFileName(url) {
        return url.split("/").pop();
      }
      const documentName = getPdfFileName(post.field_document);
      setSelectedMedia({ name: documentName });
      setDocumentLink(post.field_document);
    }
  }, [post]);

  const extraFields = useMemo(() => {
    const documentData = documentId ? { field_document: documentId } : {};
    return { ...documentData };
  }, [documentId]);

  const renderSelectedDocument = () => {
    if (!selectedMedia) return null;
    return (
      <Box display="flex" alignItems="center" gap={2} mt={2}>
        <ArticleOutlinedIcon fontSize="large" />
        <Typography variant="body1">{selectedMedia.name}</Typography>
      </Box>
    );
  };

  return (
    <PostEdit
      apiEndpoint={apiEndpoints.documents}
      screenClassName={"documents"}
      categoryTitle={"Document category"}
      categoryName={"field_document_category"}
      targetVid={"document_categories"}
      returnRoute={"/documents-creator"}
      backBtnText={"Document Library"}
      previewRoute={"/documents/preview"}
      logCustomEventType={"Document"}
      extraFields={extraFields}
      editorProps={{ onlySummary: true }}
      disableReactionsToggle={true}
      previewOverride={documentLink}
      setEntityPost={(_post) => {
        console.log("Setting post in DocumentEdit:", _post);
        setPost(_post);
      }}
    >
      <Button
        variant="outlined"
        component="label"
        size="small"
        onClick={() => setShowMediaLibrary(true)}
      >
        Select document
      </Button>
      {renderSelectedDocument()}
      {showMediaLibrary && (
        <MediaLibrary
          user={user}
          csrf_token={csrf_token}
          mediaType={"document"}
          showMediaLibrary={showMediaLibrary}
          setShowMediaLibrary={setShowMediaLibrary}
          onMediaInsert={(media) => {
            console.log("Selected media from MediaLibrary:", media);
            setDocumentLink(media.field_media_document);
            setDocumentId(media.mid);
            setSelectedMedia(media);
            setShowMediaLibrary(false);
          }}
        />
      )}
    </PostEdit>
  );
}
